export enum WidgetType {
  CreditStatus = 'Credit Status',
  Payments = 'Payments',
  MeterConsumption = 'Meter Consumption',
  Bills = 'Bills',
  AccountBalance = 'Account Balance'
}
